export default __webpack_public_path__ + "static/media/SWT1180.34I-43187_-25817_0.14de8194.jpg";